import {
  IEmailTemplate,
  CreateEmailTemplateRequest,
  UpdateEmailTemplateRequest,
  GetEmailTemplatesResponse,
  CheckLinkResult,
} from '../../types/emailTemplate/emailTemplate.types';

// Action type constants
export const GET_EMAIL_TEMPLATES_REQUEST = 'GET_EMAIL_TEMPLATES_REQUEST';
export const GET_EMAIL_TEMPLATES_SUCCESS = 'GET_EMAIL_TEMPLATES_SUCCESS';
export const GET_EMAIL_TEMPLATES_FAILURE = 'GET_EMAIL_TEMPLATES_FAILURE';

export const GET_EMAIL_TEMPLATE_REQUEST = 'GET_EMAIL_TEMPLATE_REQUEST';
export const GET_EMAIL_TEMPLATE_SUCCESS = 'GET_EMAIL_TEMPLATE_SUCCESS';
export const GET_EMAIL_TEMPLATE_FAILURE = 'GET_EMAIL_TEMPLATE_FAILURE';

export const CREATE_EMAIL_TEMPLATE_REQUEST = 'CREATE_EMAIL_TEMPLATE_REQUEST';
export const CREATE_EMAIL_TEMPLATE_SUCCESS = 'CREATE_EMAIL_TEMPLATE_SUCCESS';
export const CREATE_EMAIL_TEMPLATE_FAILURE = 'CREATE_EMAIL_TEMPLATE_FAILURE';

export const UPDATE_EMAIL_TEMPLATE_REQUEST = 'UPDATE_EMAIL_TEMPLATE_REQUEST';
export const UPDATE_EMAIL_TEMPLATE_SUCCESS = 'UPDATE_EMAIL_TEMPLATE_SUCCESS';
export const UPDATE_EMAIL_TEMPLATE_FAILURE = 'UPDATE_EMAIL_TEMPLATE_FAILURE';

export const DELETE_EMAIL_TEMPLATE_REQUEST = 'DELETE_EMAIL_TEMPLATE_REQUEST';
export const DELETE_EMAIL_TEMPLATE_SUCCESS = 'DELETE_EMAIL_TEMPLATE_SUCCESS';
export const DELETE_EMAIL_TEMPLATE_FAILURE = 'DELETE_EMAIL_TEMPLATE_FAILURE';

export const SET_SELECTED_EMAIL_TEMPLATE_ID = 'SET_SELECTED_EMAIL_TEMPLATE_ID';

export const CLEAR_EMAIL_TEMPLATE_SUCCESS = 'CLEAR_EMAIL_TEMPLATE_SUCCESS';
export const CLEAR_EMAIL_TEMPLATE_CREATE_SUCCESS =
  'CLEAR_EMAIL_TEMPLATE_CREATE_SUCCESS';
export const CLEAR_EMAIL_TEMPLATE_UPDATE_SUCCESS =
  'CLEAR_EMAIL_TEMPLATE_UPDATE_SUCCESS';
export const CLEAR_EMAIL_TEMPLATE_ERROR = 'CLEAR_EMAIL_TEMPLATE_ERROR';

export const CHECK_LINKS_REQUEST = 'CHECK_LINKS_REQUEST';
export const CHECK_LINKS_SUCCESS = 'CHECK_LINKS_SUCCESS';
export const CHECK_LINKS_FAILURE = 'CHECK_LINKS_FAILURE';
export const CLEAR_CHECK_LINKS_RESULT = 'CLEAR_CHECK_LINKS_RESULT';

// Action interfaces
export interface GetEmailTemplatesRequestAction {
  type: typeof GET_EMAIL_TEMPLATES_REQUEST;
  [key: string]: any;
}

export interface GetEmailTemplatesSuccessAction {
  type: typeof GET_EMAIL_TEMPLATES_SUCCESS;
  payload: GetEmailTemplatesResponse;
  [key: string]: any;
}

export interface GetEmailTemplatesFailureAction {
  type: typeof GET_EMAIL_TEMPLATES_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface GetEmailTemplateRequestAction {
  type: typeof GET_EMAIL_TEMPLATE_REQUEST;
  payload: string; // campaignId
  [key: string]: any;
}

export interface GetEmailTemplateSuccessAction {
  type: typeof GET_EMAIL_TEMPLATE_SUCCESS;
  payload: IEmailTemplate | null;
  [key: string]: any;
}

export interface GetEmailTemplateFailureAction {
  type: typeof GET_EMAIL_TEMPLATE_FAILURE;
  payload: { templateId: string; error: string };
  [key: string]: any;
}

export interface CreateEmailTemplateRequestAction {
  type: typeof CREATE_EMAIL_TEMPLATE_REQUEST;
  payload: CreateEmailTemplateRequest;
  [key: string]: any;
}

export interface CreateEmailTemplateSuccessAction {
  type: typeof CREATE_EMAIL_TEMPLATE_SUCCESS;
  payload: IEmailTemplate;
  [key: string]: any;
}

export interface CreateEmailTemplateFailureAction {
  type: typeof CREATE_EMAIL_TEMPLATE_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface UpdateEmailTemplateRequestAction {
  type: typeof UPDATE_EMAIL_TEMPLATE_REQUEST;
  payload: { id: string; data: UpdateEmailTemplateRequest };
  [key: string]: any;
}

export interface UpdateEmailTemplateSuccessAction {
  type: typeof UPDATE_EMAIL_TEMPLATE_SUCCESS;
  payload: IEmailTemplate;
  [key: string]: any;
}

export interface UpdateEmailTemplateFailureAction {
  type: typeof UPDATE_EMAIL_TEMPLATE_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface DeleteEmailTemplateRequestAction {
  type: typeof DELETE_EMAIL_TEMPLATE_REQUEST;
  payload: string; // templateId
  [key: string]: any;
}

export interface DeleteEmailTemplateSuccessAction {
  type: typeof DELETE_EMAIL_TEMPLATE_SUCCESS;
  payload: string; // templateId
  [key: string]: any;
}

export interface DeleteEmailTemplateFailureAction {
  type: typeof DELETE_EMAIL_TEMPLATE_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearEmailTemplateSuccessAction {
  type: typeof CLEAR_EMAIL_TEMPLATE_SUCCESS;
  [key: string]: any;
}

export interface ClearEmailTemplateCreateSuccessAction {
  type: typeof CLEAR_EMAIL_TEMPLATE_CREATE_SUCCESS;
  [key: string]: any;
}

export interface ClearEmailTemplateUpdateSuccessAction {
  type: typeof CLEAR_EMAIL_TEMPLATE_UPDATE_SUCCESS;
  [key: string]: any;
}

export interface ClearEmailTemplateErrorAction {
  type: typeof CLEAR_EMAIL_TEMPLATE_ERROR;
  [key: string]: any;
}

export interface CheckLinksRequestAction {
  type: typeof CHECK_LINKS_REQUEST;
  payload: string[];
  [key: string]: any;
}

export interface CheckLinksSuccessAction {
  type: typeof CHECK_LINKS_SUCCESS;
  payload: CheckLinkResult[];
  [key: string]: any;
}

export interface CheckLinksFailureAction {
  type: typeof CHECK_LINKS_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearCheckLinksResultAction {
  type: typeof CLEAR_CHECK_LINKS_RESULT;
  [key: string]: any;
}

// Union type for all email template actions
export type EmailTemplatesActionTypes =
  | GetEmailTemplatesRequestAction
  | GetEmailTemplatesSuccessAction
  | GetEmailTemplatesFailureAction
  | GetEmailTemplateRequestAction
  | GetEmailTemplateSuccessAction
  | GetEmailTemplateFailureAction
  | CreateEmailTemplateRequestAction
  | CreateEmailTemplateSuccessAction
  | CreateEmailTemplateFailureAction
  | UpdateEmailTemplateRequestAction
  | UpdateEmailTemplateSuccessAction
  | UpdateEmailTemplateFailureAction
  | DeleteEmailTemplateRequestAction
  | DeleteEmailTemplateSuccessAction
  | DeleteEmailTemplateFailureAction
  | ClearEmailTemplateSuccessAction
  | ClearEmailTemplateCreateSuccessAction
  | ClearEmailTemplateUpdateSuccessAction
  | ClearEmailTemplateErrorAction
  | CheckLinksRequestAction
  | CheckLinksSuccessAction
  | CheckLinksFailureAction
  | ClearCheckLinksResultAction;
